import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

export function skipLoader(context: HttpContext = new HttpContext()): HttpContext {
  return context.set(SKIP_LOADER, true);
}
